import React, { useState } from "react";
import { Accordion } from "react-bootstrap";
import { aboutFoodsIcon } from "../../Constants/Images";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import { SpaceTypes } from "../../Constants/Interfaces";
import AboutAccordian from "./AboutAccordian";

interface HealthSafetyTabType {
  item: SpaceTypes;
}

const HealthSafetyTab: React.FC<HealthSafetyTabType> = ({ item }) => {
  return (
    <div className="about-tab-wrapper">
      <div className="about-content">
        <h2>Enhanced Health and Safety Measures</h2>
        <p>
          There will be a cleaning supplies under the bar as well as trash cans.
        </p>
      </div>

      <AboutAccordian type="health_and_safety" details={item.details} />
    </div>
  );
};

export default HealthSafetyTab;
